import { useContext } from "react";
import { useSchema } from "../../../hooks/useStore";
import { cn } from "../../../utils";
import { renderData } from "../UiRenderer";
import { appendPath, prettierTitle, sortObjectWithSchema } from "../utils";
import { ViewContext } from "../View";

const ifContainsPublicIdentifier = (schema) => {
  return Object.values(schema).some(
    (value) => value.function === "publicIdentifier"
  );
};

export const ObjectRenderer = ({
  infoObjectName,
  path,
  name,
  data,
  options: { hideKeys = false },
  is: { floatingWindow },
}) => {
  const { rendered } = useContext(ViewContext);
  const schema = useSchema(infoObjectName, path);

  const hasPublicIdentifier = ifContainsPublicIdentifier(schema);
  let indOffset = hasPublicIdentifier ? 999 : 0;
  if (hasPublicIdentifier) {
    data = sortObjectWithSchema(data, schema);
  }

  return (
    <div
      className={cn(
        "r-object-container",
        rendered && "r-rendered",
        hideKeys && !floatingWindow && "r-minimal",
        floatingWindow && "r-object-is-floating-window"
      )}
    >
      {!hideKeys && (
        <div className={cn("r-obj-key r-key", rendered && "r-rendered")}>
          {prettierTitle(name)}
        </div>
      )}

      <div className={cn("r-object", rendered && "r-rendered")}>
        {Object.entries(data).map(([key, value], index) => {
          if (key === "id" || key.includes("_id")) {
            indOffset--;
            return null;
          }

          return renderData(
            infoObjectName,
            appendPath(path, key),
            key,
            value,
            schema[key],
            {
              isPrimary:
                index + indOffset === 0 && Object.keys(data).length > 2, // ! A RULE
            }
          );
        })}
      </div>
    </div>
  );
};
